import script from "./QActsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QActsItem.vue?vue&type=script&setup=true&lang=js"

import "./QActsItem.vue?vue&type=style&index=0&id=49480960&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49480960"]])

export default __exports__